package com.arena_web.ui.components.charts

import androidx.compose.runtime.Composable
import com.arena_web.ui.theme.hex
import com.arena_web.ui.utils.sBorderRadius
import com.arena_web.ui.utils.sSize
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor

enum class OccupancyLevel(val label: String, val color: Color) {
    Empty("Empty", Color.hex("00143b")),
    Low("Low (1-30%)", Color.hex("00245d")),
    Medium("Medium (31-60%)", Color.hex("0a2e67")),
    High("High (61-90%)", Color.hex("004390")),
    Full("Full (91-100%)", Color.hex("0064b1"))
}

@Composable
fun HeatmapCell(
    level: OccupancyLevel,
    modifier: Modifier = Modifier
) {
    Box(
        modifier
            .sSize(24)
            .sBorderRadius(4)
            .backgroundColor(level.color)
    )
}
